import MycorrLogo from "@/assets/images/MycorrMedium.svg?react";

// SVG uses stroke="currentColor" — works for both light and dark themes.
// Imported as React component (not URL) so it's inlined in the JS bundle
// and always available offline.
export const useThemedLogo = () => MycorrLogo;
